import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay, FreeMode } from 'swiper/modules';
import iconArrow from "../../static/icon-arrow.svg";
import iconService1 from "../../static/icon-service-1.svg";
import iconService2 from "../../static/icon-service-2.svg";
import iconService3 from "../../static/icon-service-3.svg";

import LogoTecAws from "../../static/logo-tec-aws.png";
import LogoTecDocker from "../../static/logo-tec-docker.png";
import LogoTecGoogleCloud from "../../static/logo-tec-google-cloud.png";
import LogoTecWordPress from "../../static/logo-tec-wordpress.png";
import LogoTecTray from "../../static/logo-tec-tray.png";
import LogoTecNuvemShop from "../../static/logo-tec-nuvemshop.png";
import LogoTecShopify from "../../static/logo-tec-shopify.png";
import LogoTecSpring from "../../static/logo-tec-spring.png";
import LogoTecJava from "../../static/logo-tec-java.png";
import LogoTecReact from "../../static/logo-tec-react.png";
import LogoTecLaravel from "../../static/logo-tec-laravel.png";

import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/free-mode';
import "./Tecnology.scss";

function Tecnology() {
    let slidesPerView = 4;
    let speed = 3500;

    if (window.innerWidth < 768) {
        slidesPerView = 1;
        speed = 2000;
    }

    return(
        <section className="tecnology" id="tecnology">
            <div className="container">
                <div className="tecnology__wrapper">
                    <h2 className="title"><span>Tecnologias</span>O que move nossos projetos</h2>

                    <Swiper
                        className="tecnology__wrapper__cards"                        
                        modules={[ Autoplay, FreeMode ]}
                        loop={true}
                        speed={speed}
                        slidesPerView={slidesPerView}
                        freeMode={true}
                        allowTouchMove={false}
                        simulateTouch={false}
                        autoplay={{
                            delay: 0,
                            pauseOnMouseEnter: false,
                            disableOnInteraction: false,
                            stopOnLastSlide: false,
                        }}
                    >
                        <SwiperSlide>
                            <div className="tecnology__wrapper__cards__card">
                                <img src={LogoTecWordPress} alt="Logo WordPress"/>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="tecnology__wrapper__cards__card">
                                <img src={LogoTecNuvemShop} alt="Logo NuvemShop"/>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="tecnology__wrapper__cards__card">
                                <img src={LogoTecShopify} alt="Logo Shopify"/>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="tecnology__wrapper__cards__card">
                                <img src={LogoTecTray} alt="Logo Tray"/>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="tecnology__wrapper__cards__card">
                                <img src={LogoTecGoogleCloud} alt="Logo Google Cloud"/>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="tecnology__wrapper__cards__card">
                                <img src={LogoTecReact} alt="Logo React"/>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="tecnology__wrapper__cards__card">
                                <img src={LogoTecJava} alt="Logo Java"/>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="tecnology__wrapper__cards__card">
                                <img src={LogoTecSpring} alt="Logo Spring"/>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="tecnology__wrapper__cards__card">
                                <img src={LogoTecLaravel} alt="Logo Laravel"/>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="tecnology__wrapper__cards__card">
                                <img src={LogoTecAws} alt="Logo AWS"/>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="tecnology__wrapper__cards__card">
                                <img src={LogoTecDocker} alt="Logo Docker"/>
                            </div>
                        </SwiperSlide>
                    </Swiper>
                </div>
            </div>
        </section>
    )
}

export default Tecnology;